import { Pipe, PipeTransform } from '@angular/core'
import { User } from './../../shared/models/user.model'

@Pipe({ name: 'userFilter' })
export class UserFilterPipe implements PipeTransform {
  public transform (users: User[], searchText: string): any[] {
    if (!users) return []
    if (!searchText) return users
    searchText = searchText.toLowerCase()
    return users.filter((it) => {
      return (
        it.name.toLowerCase().includes(searchText) ||
        it.username.toLowerCase().includes(searchText)
      )
    })
  }
}
